import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { SITE, NAV } from "../lib/site";
import Logo from "./Logo";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#F9F8F6]/95 backdrop-blur border-b border-[#D5CABD]"
            data-testid="site-navbar">
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-home-link">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\W/g, "") || "home"}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[#7A2E39]" : "text-gray-700 hover:text-[#7A2E39]"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/devis" className="btn-ghost text-sm" data-testid="nav-devis-cta">
            Devis gratuit
          </Link>
          <a
            href={`tel:${SITE.phoneRaw}`}
            className="btn-primary"
            data-testid="cta-call-navbar"
          >
            <Phone className="w-4 h-4" /> {SITE.phone}
          </a>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#D5CABD] bg-[#F9F8F6]" data-testid="mobile-menu">
          <div className="container-x py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `py-2 text-base ${isActive ? "text-[#7A2E39] font-semibold" : "text-gray-800"}`
                }
                data-testid={`mobile-nav-${n.to.replace(/\W/g, "") || "home"}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`tel:${SITE.phoneRaw}`}
              className="btn-primary mt-3"
              data-testid="cta-call-mobile"
            >
              <Phone className="w-4 h-4" /> {SITE.phone}
            </a>
            <Link
              to="/devis"
              onClick={() => setOpen(false)}
              className="btn-ghost mt-2"
              data-testid="mobile-devis-cta"
            >
              Devis gratuit en ligne
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
